import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/cartoonbg.png";
import homeLogo from "../../Assets/kimono.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillFacebook,
  AiFillLinkedin,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useTranslation } from "react-i18next";

function Home2() {
  const { t } = useTranslation();
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              {t("introduction")}{" "}
              <span className="purple"> {t("introduction")} </span>
            </h1>
            <p className="home-about-body">
              {t("description")}
              <br />
              <br />
              {t("job")}{" "}
              <i>
                <b className="purple">{t("job_position")}</b>
              </i>
              <br />
              <br />
              {t("hobbies")}{" "}
              <i>
                <b className="purple">{t("food_interest")}</b>
              </i>
              <br />
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={homeLogo} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>{t("find_me")}</h1>
            <p>
              {t("connect_with_me")}
              <span className="purple">{t("connected")}</span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/karuna.shrestha.7146"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
